<template>
  <v-card
    class="pa-12 dashboard"
    flat
  >
    <v-row>
      <v-col
        elevation="2"
        cols="12" md="4" sm="12"
        v-for="menu in menus"
              :key="menu.header"
              
      >
       <v-card v-if="menu.gate === undefined || checkGate(menu.gate) ">
         <v-subheader :inset="true">
            {{menu.header}}
          </v-subheader>
          <v-navigation-drawer
            floating
            permanent
          >
            <v-list
              dense
              rounded
            >
              <v-list-item
         
                v-for="item in menu.items"
                :key="item.title"
                :to="item.path"  
                link
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
      
              </v-list-item>
              <v-list-item>
              <!-- <v-btn small v-if="menu.header == 'Bookeo'" :href="'https://signin.bookeo.com/?authappid=JRC94TKRAMCL&permissions=bookings_r_all,customers_r_all&state=' + uuid" 
                              color="green"
                            >
          <v-icon left>mdi-pipe</v-icon>Connect 
                    </v-btn> -->
            </v-list-item>
            </v-list>
            
          </v-navigation-drawer>
       </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>



<script>
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {

        menus: [
           { 
            header : "Check-in", 
            items : [
              // { path: '/settings//customers', title: 'Customers' },
              { title: 'Packages',  path : 'Products' },
              { path: '/settings/agents', title: 'Agents' },
              { path: '/settings/addons', title: 'Addons' },
              { path: '/settings/merch', title: 'Merch Stock' },
              //{ path: '/settings//components', title: 'Rig Components' },
            ]
           },
           {
            header : "Manifest", 
              items : [
              { path: '/settings/instructors', title: 'Instructors' },
              { path: '/settings/pilots', title: 'Pilots' },
              { path: '/settings/packers', title: 'Packers' },
              { path: '/settings/aircrafts', title: 'Aircrafts' },
              { path: '/settings/resources', title: 'Resources' },
              // { path: '/settings//rigs', title: 'Rigs' },
              ]
           },
           { 
            header : "Users Management", 
            gate : 'users-mgmt',
            
            items : [
               { title: 'Users',  path : '/settings/users' },
               { title: 'Roles',  path : '/settings/roles' },
               { title: 'Tasks',  path : '/settings/tasks' },
              ]
            }

          // { 
          //   header : "Bookeo", 
          //   items : [
          //     { title: 'Packages',  path : 'Products' },
          //     ]
          //   }
        ],

        uuid : this.$store.state.uuid

      }
    },



  }
</script>
